// also known as "Shop By Collection"
import { waitForElements } from '../helpers/utils';
import LazyImages from './LazyImages';
import '../../styles/components/_trending-now.scss';
import Splide from '@splidejs/splide';
import { DESKTOP_WIDTH, TABLET_WIDTH } from '../vue/constants/devices';
const carouselOptions = {
    mediaQuery: "min",
    gap: "24px",
    type: 'slide',
    perPage: 1,
    arrows: false,
    pagination: false,
    breakpoints: {
        [TABLET_WIDTH]: {
            perPage: 2
        },
        [DESKTOP_WIDTH]: {
            perPage: 4,
            arrows: true
        }
    }
};
export default (() => {
    function generateHtml(sectionSettings, blocksHtml) {
        return `
    <div class="trending-now">
      <h2 class="trending-now__header">${sectionSettings.title}</h2>
      <section class="splide">
        <div class="splide__track">
          <ul class="splide__list">${blocksHtml}</ul>
        </div>
      </section>
    </div>
  `;
    }
    function render(renderEl, sectionSettings, blocksSettings) {
        const blocksHtml = blocksSettings.reduce((acc, block) => {
            const html = `
        <li class="splide__slide trending-now-block">
          <a class="trending-now-block__image-url" href="${block.url}">
            <img class="trending-now-block__image" data-src=${block.image} alt="${block.title}" loading="lazy"/>
          </a>
          <a class="trending-now-block__title" href="${block.url}">${block.title}</a>
        </li>
      `;
            return acc += html;
        }, '');
        renderEl.innerHTML = generateHtml(sectionSettings, blocksHtml);
        const splide = new Splide(renderEl.querySelector('.splide'), carouselOptions);
        splide.mount();
        LazyImages.update();
    }
    return {
        init: function () {
            console.log('UNTUCKit : Module : TrendingNow : init');
            const dataEl = document.getElementById('trending-now-data');
            // when a/b testing via Shogun, element won't be in DOM when this script is run
            waitForElements('#trending-now-container').then((els) => {
                var _a, _b, _c, _d;
                const renderEl = els[0];
                if (dataEl && renderEl) {
                    const sectionSettingsText = (_b = (_a = dataEl.querySelector("#trending-now-data--section-settings")) === null || _a === void 0 ? void 0 : _a.textContent) === null || _b === void 0 ? void 0 : _b.trim();
                    const blocksSettingsText = (_d = (_c = dataEl.querySelector("#trending-now-data--blocks-settings")) === null || _c === void 0 ? void 0 : _c.textContent) === null || _d === void 0 ? void 0 : _d.trim();
                    if (sectionSettingsText && blocksSettingsText) {
                        const sectionSettings = JSON.parse(sectionSettingsText);
                        const blocksSettings = JSON.parse(blocksSettingsText);
                        if (sectionSettings && blocksSettings && blocksSettings.length) {
                            render(renderEl, sectionSettings, blocksSettings);
                        }
                    }
                    else {
                        console.log('cannot render Trending Now; required settings are missing');
                    }
                }
                else {
                    console.log('cannot render Trending Now; required elements are missing');
                }
            }).catch(() => { console.log('Trending Now container not found.'); });
        }
    };
})();
